import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/hedge',
  component: Layout,
  redirect: '/hedge/index',
  name: 'hedge',
  meta: {
    title: '对冲',
    i18n: 'route.tabbar',
    icon: 'game-icons:3d-glasses',
  },
  children: [
    {
      path: 'index',
      name: 'hedgeIdex',
      component: () => import('@/views/hedge/index.vue'),
      meta: {
        title: '对冲',
        i18n: 'route.tabbar',
        menu: false,
        breadcrumb: false,
        activeMenu: '/hedge',
      },
    },
  ],
}

export default routes
